import { init, t as translate } from 'i18next';
import { ru } from './ru/index';

/**
 * Словарь интерфейса — одно место на всё приложение.
 *
 * Язык у нас один, и второго не планируется: приложение для русскоязычного
 * проекта. Библиотеку завели не ради перевода, а ради СКЛОНЕНИЙ: «1 решение»,
 * «2 решения», «5 решений» — три формы, и выбирать между ними по остатку от
 * деления руками мы больше не будем. Формы пишутся у ключа суффиксами
 * `_one`/`_few`/`_many`, а какую взять, решает `Intl.PluralRules` платформы.
 *
 * Тексты API сюда НЕ уезжают: они английские и приходят с сервера как есть —
 * это записано в CLAUDE.md и остаётся в силе.
 *
 * Обёртки `react-i18next` здесь нет намеренно. Её `useTranslation` нужен,
 * чтобы перерисовать дерево при СМЕНЕ языка; языка у нас один и меняться ему
 * негде, а хук взамен запретил бы звать словарь откуда угодно, кроме тела
 * компонента, — тогда как половина подписей собирается в помощниках и картах.
 */
void init({
  lng: 'ru',
  fallbackLng: 'ru',
  // Второго языка нет, и подмешивать нечего: недостающий ключ — это ошибка
  // разработки, и пусть она видна ключом на экране, а не молчаливой пустотой.
  resources: { ru: { translation: ru } },
  interpolation: {
    // React экранирует сам, а двойное экранирование ломает кавычки-ёлочки.
    escapeValue: false,
  },
  returnNull: false,
});

/** Единственный вход в словарь. */
export const t = translate;
